var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('info-page-container',[_c('content-info-wrapper',{attrs:{"title":_vm._('404!'),"subtitle":_vm._('Вы таки потерялись!')}},[_c('control-button',{attrs:{"styling":"primary","tag":"a","href":"/"}},[_vm._v(_vm._s(_vm._('В кабинет')))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }